module.exports = __webpack_public_path__ + "static/media/whack_img_3.312bf207.png";